export interface PromiseItem {
  title: string;
  detail: string;
}

export const SWC_PROMISE: readonly PromiseItem[] = [
  {
    title: 'No Excessive Fees',
    detail: 'Honest pricing. No hidden surcharges, no surprise add-ons at checkout.',
  },
  {
    title: '100% Guarantee · No-Questions Returns',
    detail: "If a part isn't exactly as documented, send it back. Full refund, no debate.",
  },
  {
    title: 'Full Tech Line on Every Sale',
    detail: 'Direct phone access to authentication and tech support on every part you buy.',
  },
  {
    title: 'Free Shipping Under 100 lbs',
    detail: 'If we can box it, we ship it free in the continental US.',
  },
  {
    title: "Can't Find It? We'll Source It.",
    detail: "Tell us what your build needs. We'll work our network and bring it to you.",
  },
] as const;
